import { Subject } from "rxjs";

import log2 from "./log2";

import app from "../store/modules/app";
import { encodeVisitorPayload, isJsonDebugModeEnabled, TUNNEL_EVENT } from "./visitorPayloadCodec";

const messages = new Subject();
const log = log2("SocketStream");
let socket = null;
let visitorSocketReady = false;
const pendingSocketMessages = [];

export const addSocketMessage = (cmd, data) => {
    log.debug("addSocketMessage", { cmd, data });
    messages.next({
        cmd,
        data,
    });
};

const emitSocketMessage = (type, payload) => {
    if (isJsonDebugModeEnabled()) {
        log.debug("sendSocketMessage (json debug mode)", { type, payload });
        socket.emit(type, payload);
        return;
    }
    log.debug("sendSocketMessage (binary)", { type, payload });
    socket.emit(TUNNEL_EVENT, encodeVisitorPayload({ e: type, d: payload }));
};

export const sendSocketMessage = (type, payload) => {
    if (!socket) return;
    if (!visitorSocketReady && type !== "visitor connect") {
        log.debug("sendSocketMessage queued until visitor token", { type });
        pendingSocketMessages.push({ type, payload });
        return;
    }
    emitSocketMessage(type, payload);
};

export const markVisitorSocketReady = () => {
    if (visitorSocketReady) return;
    visitorSocketReady = true;
    const queued = pendingSocketMessages.splice(0, pendingSocketMessages.length);
    queued.forEach((item) => {
        emitSocketMessage(item.type, item.payload);
    });
};

export const socketMessageStream = messages.asObservable();

export const updateSocketRef = (s) => {
    socket = s;
    visitorSocketReady = false;
    pendingSocketMessages.splice(0, pendingSocketMessages.length);
};



// WEBPACK FOOTER //
// ./src/utils/socketStream.js